var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenFeatureCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2.00195L16.8916 2.14179L6.80608 12.2273L3.10841 8.52962L0 8.38978L0.13984 11.4982L3.83752 15.1959L3.83672 15.1967L6.80529 18.1652L6.80608 18.1644L6.80828 18.1666L9.77684 15.1981L9.77465 15.1959L19.8602 5.11036L20 2.00195Z",
    fill: "#93ECC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenFeatureCheckmark);
export default __webpack_public_path__ + "static/media/GreenFeatureCheckmark.4dc2c2fabb6708a25def25ef8f2ce3e7.svg";
export { ForwardRef as ReactComponent };